import moment from 'moment';

import { TASKS_SUB_PAGES } from './task-manager.constants';

export const getDueToDays = (dueTo: string | Date) => {
  const startOfCurrentDay = moment().startOf('day');

  return moment(dueTo)
    .startOf('day')
    .diff(startOfCurrentDay, 'days');
};

export const getDefaultTab = (type: string) => {
  if (type === TASKS_SUB_PAGES.tasks) {
    return TASKS_SUB_PAGES.tasks;
  }

  return type;
};
